<form [formGroup]="templateForm" (ngSubmit)="saveTemplate()" [hidden]="!formTemplateVisible">
  <div class="form-group">
    <select class="custom-select form-control mb-2 mr-2" id="type" formControlName="type"
      [ngClass]="{ 'is-invalid': templateFormSubmitted && templateForm.get('type').hasError('required') }"
      (change)="onTypeChange($event)">
      <option  [value]="''" disabled>Crie um novo template</option>
      <option *ngFor="let type of template_types" [value]="type.id">{{ type.name }}</option>
    </select>
    <small class="invalid-feedback" *ngIf="templateFormSubmitted && templateForm.get('type').hasError('required')">
      Tipo não foi informado
    </small>
  </div>
  <div *ngIf="optionTemplateSelected" style="display: contents;">
    <div class="form-group">
      <input placeholder="Nome do template" formControlName="nameTemplate" class="form-control mb-2"  size="100" type="text" [ngClass]="{ 'is-invalid': templateForm.get('nameTemplate').hasError('required') }">
      <small class="invalid-feedback"
        *ngIf="templateFormSubmitted && templateForm.get('nameTemplate').hasError('required')">
        Título não foi informado
      </small>
    </div>
    <button type="submit" [attr.data-loader]="!templateFormSubmitted" btnloader [hidden]="!projectId"
      style="margin-left: 0;" class="btn btn-primary btn-outline-primary mb-3 ml-3">
      Salvar
    </button>
  </div>
</form>